import AFSHAR from "Assets/Images/afshar.jpeg";
import HABIBI from "Assets/Images/habibi.jpeg";
import SHAMSA from "Assets/Images/shamsa.jpeg";
import POURTALEB from "Assets/Images/pourtaleb.jpeg";

export const passengerData = [
  {
    id: 1,
    name: "محمدرضا افشاری شریف ابادی",
    src: AFSHAR,
    phoneNumber: "09199814978",
    joinDate: "1403/01/02",
    ticketCode: "ADCBD",
    buyDate: "12:20 1403/04/0",
    port: "پاسارگارد",
    payStatus: true,
    active: true,
    pathOffer: {
      source: "عباس اباد",
      destination: "تهرانسر",
      go_Time: "8:10",
      arrive_Time: "9:00",
      registerDate: "1403/07/15",
      lastTicket: {
        code: "ADCGO4",
        source: "یاخچی اباد",
        destination: "ونک",
        go_Time: "10:10",
        arrive_Time: "11:15",
      },
    },
  },
  {
    id: 2,
    name: "مهدی پورطالبی",
    src: POURTALEB,
    phoneNumber: "09122140235",
    joinDate: "1403/02/12",
    ticketCode: "ADYYD",
    buyDate: "14:20 1403/03/05",
    port: "پاسارگارد",
    payStatus: true,
    active: true,
    pathOffer: {
      source: "نازی اباد",
      destination: "تهرانپارس",
      go_Time: "12:10",
      arrive_Time: "13:20",
      registerDate: "1403/05/02",
      lastTicket: {
        code: "AXQTS2",
        source: "منظریه",
        destination: "تهرانپارس",
        go_Time: "12:50",
        arrive_Time: "13:50",
      },
    },
  },
  {
    id: 3,
    name: "میلاد شمسایی",
    src: SHAMSA,
    phoneNumber: "09362104591",
    joinDate: "1403/03/18",
    ticketCode: "LDTYR",
    buyDate: "14:55 1403/04/15",
    port: "پاسارگارد",
    payStatus: true,
    active: true,
    pathOffer: {
      source: "سعادت اباد",
      destination: "آزادی",
      go_Time: "10:10",
      arrive_Time: "11:00",
      registerDate: "1403/05/14",
      lastTicket: {
        code: "ADPEC1",
        source: "کامرانیه",
        destination: "تجریش",
        go_Time: "19:10",
        arrive_Time: "19:30",
      },
    },
  },
  {
    id: 4,
    name: "مهدی حبیب زاده",
    src: HABIBI,
    phoneNumber: "09012574815",
    joinDate: "1403/04/08",
    ticketCode: "PFBYD",
    buyDate: "16:55 1403/05/17",
    port: "پاسارگارد",
    payStatus: true,
    active: true,
    pathOffer: {
      source: "یافت اباد",
      destination: "ولنجک",
      go_Time: "7:15",
      arrive_Time: "8:25",
      registerDate: "1403/03/18",
      lastTicket: {
        code: "MKWGY5",
        source: "مولوی",
        destination: "انقلاب",
        go_Time: "16:10",
        arrive_Time: "16:55",
      },
    },
  },
];
